/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Filter values for unresolved observation admin list
 * @export
 * @interface MdmUnresolvedObservationFiltersResponse
 */
export interface MdmUnresolvedObservationFiltersResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    statuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    sourceSystems?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    reasonCodes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    observationRoutes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MdmUnresolvedObservationFiltersResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MdmUnresolvedObservationFiltersResponse interface.
 */
export function instanceOfMdmUnresolvedObservationFiltersResponse(value: object): value is MdmUnresolvedObservationFiltersResponse {
    return true;
}

export function MdmUnresolvedObservationFiltersResponseFromJSON(json: any): MdmUnresolvedObservationFiltersResponse {
    return MdmUnresolvedObservationFiltersResponseFromJSONTyped(json, false);
}

export function MdmUnresolvedObservationFiltersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmUnresolvedObservationFiltersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'sourceSystems': json['sourceSystems'] == null ? undefined : json['sourceSystems'],
        'reasonCodes': json['reasonCodes'] == null ? undefined : json['reasonCodes'],
        'observationRoutes': json['observationRoutes'] == null ? undefined : json['observationRoutes'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MdmUnresolvedObservationFiltersResponseToJSON(json: any): MdmUnresolvedObservationFiltersResponse {
    return MdmUnresolvedObservationFiltersResponseToJSONTyped(json, false);
}

export function MdmUnresolvedObservationFiltersResponseToJSONTyped(value?: MdmUnresolvedObservationFiltersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'statuses': value['statuses'],
        'sourceSystems': value['sourceSystems'],
        'reasonCodes': value['reasonCodes'],
        'observationRoutes': value['observationRoutes'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

